var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"dot",class:_vm.statusDotClass,staticStyle:{"display":"inline-block"}}),_vm._v(" "),(_vm.label)?_c('ui-tooltip',{attrs:{"trigger":_vm.$refs.dot}},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }